import { motion } from "framer-motion";
import { Award, ShieldCheck, Zap } from "lucide-react";
import { useStore } from "@/context/StoreContext";

const icons = [Award, ShieldCheck, Zap];

export default function ValueBadges() {
  const { t } = useStore();

  return (
    <section data-testid="value-badges-section" className="bg-black py-20 lg:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-5 px-4 sm:grid-cols-3 sm:px-6 lg:gap-8 lg:px-8">
        {t.values.map((v, i) => {
          const Icon = icons[i];
          return (
            <motion.div
              key={v.title}
              data-testid={`value-badge-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.12, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-ink-card p-8 transition-colors duration-500 hover:border-ember/40 lg:p-10"
            >
              <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-ember/0 blur-2xl transition-colors duration-500 group-hover:bg-ember/15" />
              <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl border border-ember/30 bg-ember/10 text-ember transition-transform duration-500 group-hover:-translate-y-1">
                <Icon size={20} />
              </div>
              <h3 className="font-display text-xl font-bold tracking-wide text-white lg:text-2xl">
                {v.title}
              </h3>
              <p className="mt-2 text-sm text-mist">{v.desc}</p>
              <span className="mt-6 block h-px w-full bg-gradient-to-r from-ember/50 to-transparent" />
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
